/**
 * hey-cart — klientlogik for Hey-kurvfunktionerne i kurv-draweren.
 *
 * Draweren (#cart) får sin innerHTML udskiftet af temaets handleCartPanel()
 * ved hver kurvændring. Vi observerer #cart og:
 *   1) udfører gave-tilføjelse/-fjernelse ud fra server-beregnede signaler
 *      (data-hey-gift-actions fra hey-cart-progress.liquid),
 *   2) henter anbefalinger via /recommendations/products ind i
 *      [data-hey-recs] (hey-cart-recommendations.liquid),
 *   3) dispatcher temaets eget 'ajaxCart'-event, så alle form.f8pr bindes
 *      af formOverride() — selve add-to-cart kører 100 % i temaets pipeline.
 *
 * Kurv-opdateringer efter gavehandlinger afleveres til temaets egen
 * re-render via ajaxCart.load(response) (Section Rendering API).
 */
(function () {
  'use strict';

  /* Tema-fejl-fix (rammer også live-temaet, kører selv med ?hey=off):
     what-input i scripts-async.js sætter kun data-whatin på <html> ved
     SKIFT af input-type, og typen huskes i sessionStorage — derfor
     mangler attributten på alle sider efter den første i en fane, og
     alle hover-menuer (dropdown-navigationen) er døde, indtil brugeren
     tilfældigvis taster og derefter flytter musen. Vi sætter den selv. */
  function fixWhatin(type) {
    var html = document.documentElement;
    if (html.getAttribute('data-whatin')) { return; }
    var intent = type || html.getAttribute('data-whatintent');
    if (intent && intent !== 'initial') { html.setAttribute('data-whatin', intent); }
  }
  var whatinObserver = new MutationObserver(function () {
    fixWhatin();
    if (document.documentElement.getAttribute('data-whatin')) { whatinObserver.disconnect(); }
  });
  whatinObserver.observe(document.documentElement, { attributes: true, attributeFilter: ['data-whatintent'] });
  // { once: true }: attributten skal kun sættes én gang — tidligere kørte
  // dette ved HVER musebevægelse og kostede unødigt arbejde under scroll
  window.addEventListener('mousemove', function () { fixWhatin('mouse'); }, { passive: true, once: true });
  window.addEventListener('touchstart', function () { fixWhatin('touch'); }, { passive: true, once: true });
  fixWhatin();

  /* Kill-switch til fejlsøgning: ?hey=off slår AL Hey-funktionalitet fra
     (JS, CSS, paneler) for resten af browser-sessionen; ?hey=on slår til igen. */
  var heyOff = false;
  try {
    if (/[?&]hey=on\b/.test(location.search)) { sessionStorage.removeItem('heyOff'); }
    else if (/[?&]hey=off\b/.test(location.search)) { sessionStorage.setItem('heyOff', '1'); }
    heyOff = sessionStorage.getItem('heyOff') === '1';
  } catch (e) {}
  if (heyOff) {
    document.querySelectorAll('link[href*="hey-cart.css"]').forEach(function (l) { l.disabled = true; });
    document.querySelectorAll('style[data-hey]').forEach(function (s) { s.remove(); });
    ['hey-cart-recs-panel', 'hey-viewed'].forEach(function (id) {
      var el = document.getElementById(id);
      if (el) { el.remove(); }
    });
    return;
  }

  /* Tracking: pusher hey_*-events til dataLayer/gtag hvis de findes —
     ingen egne cookies, ingen eksterne kald. */
  window.heyTrack = function (name, params) {
    try {
      var payload = params || {};
      if (window.dataLayer && window.dataLayer.push) {
        var d = { event: 'hey_' + name };
        for (var k in payload) { d[k] = payload[k]; }
        window.dataLayer.push(d);
      } else if (typeof window.gtag === 'function') {
        window.gtag('event', 'hey_' + name, payload);
      }
    } catch (e) {}
  };

  /* Delegeret klik-tracking på alle hey-formularers Læg i kurv */
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f.matches || !f.matches('form.f8pr')) { return; }
    var src = f.querySelector('input[name="properties[_hey_source]"]');
    if (src) { window.heyTrack('add', { source: src.value }); }
  }, true);

  var giftBusy = false;
  var giftFailed = {};
  var recsToken = 0;

  /* ---------- gaver (fase 2) ---------- */

  function handleGiftResponse(response) {
    giftBusy = false;
    if (response && response.sections && typeof ajaxCart !== 'undefined') {
      // Bevar drawerens åben-tilstand: temaets render-pipeline lukker
      // panelet undervejs, og kun showCartPanel genåbner det. Var draweren
      // åben, skal den forblive åben efter gave-/antals-opdateringen.
      var container = document.getElementById('cart');
      var keepOpen = !!(container && container.getAttribute('aria-hidden') === 'false');
      ajaxCart.load(response, keepOpen);
    }
  }

  function processGifts(container) {
    if (giftBusy) { return; }
    var el = container.querySelector('[data-hey-gift-actions]');
    if (!el) { return; }
    var removeKeys = (el.getAttribute('data-remove') || '').split(',').filter(Boolean);
    var addIds = (el.getAttribute('data-add') || '').split(',').filter(Boolean)
      .filter(function (id) { return !giftFailed[id]; });

    if (removeKeys.length) {
      giftBusy = true;
      fetch(window.Shopify.routes.root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({ id: removeKeys[0], quantity: 0, sections: 'side-cart' })
      })
        .then(function (r) { return r.json(); })
        .then(handleGiftResponse)
        .catch(function (e) { giftBusy = false; console.log('hey-cart gift remove error', e); });
    } else if (addIds.length) {
      giftBusy = true;
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: parseInt(addIds[0], 10), quantity: 1, properties: { _gift: 'true', _hey_source: 'gave' } }],
          sections: 'side-cart'
        })
      })
        .then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) { // fx udsolgt — undgå uendelig retry
            giftFailed[addIds[0]] = true;
            giftBusy = false;
            return;
          }
          window.heyTrack('gift_added', {});
          handleGiftResponse(response);
        })
        .catch(function (e) { giftFailed[addIds[0]] = true; giftBusy = false; console.log('hey-cart gift add error', e); });
    }
  }

  /* ---------- maks 1 stk. pr. tilkøb (fase 1) ---------- */

  function fixAddonQty(container) {
    if (giftBusy) { return; }
    var el = container.querySelector('[data-hey-addon-fix]');
    if (!el) { return; }
    var keys = (el.getAttribute('data-hey-addon-fix') || '').split(',').filter(Boolean);
    if (!keys.length) { return; }
    giftBusy = true;
    fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: JSON.stringify({ id: keys[0], quantity: 1, sections: 'side-cart' })
    })
      .then(function (r) { return r.json(); })
      .then(handleGiftResponse)
      .catch(function (e) { giftBusy = false; console.log('hey-cart addon qty error', e); });
  }

  /* ---------- anbefalinger (fase 3) + desktop-panel ved siden af kurven ---------- */

  function cartIsOpen(container) {
    return container.getAttribute('aria-hidden') === 'false';
  }

  // Synkroniserer KUN synlighed (kaldes også når draweren åbnes/lukkes).
  // Indholdet røres ikke her, så panelet ikke blinker under gen-hentning.
  function syncRecsPanel(container) {
    var panel = document.getElementById('hey-cart-recs-panel');
    if (!panel) { return; }
    var show = panel.getAttribute('data-has-content') === '1' && cartIsOpen(container);
    panel.hidden = false; // synlighed styres af klassen, så panelet kan glide
    panel.setAttribute('aria-hidden', show ? 'false' : 'true');
    if (show) {
      // et frame før klassen sættes, så første åbning også animerer
      requestAnimationFrame(function () {
        requestAnimationFrame(function () { panel.classList.add('is-open'); });
      });
    } else {
      panel.classList.remove('is-open');
    }
  }

  // Udskifter panelets indhold — kaldes kun når nye data er klar, så
  // panelet bliver stående og blot skifter produkter ved kurvændringer.
  function updateRecsPanelContent(container) {
    var panel = document.getElementById('hey-cart-recs-panel');
    if (!panel) { return; }
    var box = container.querySelector('[data-hey-recs]');
    var hasContent = false;
    if (box && !box.hidden) {
      var list = box.querySelector('[data-hey-recs-list]');
      hasContent = !!(list && list.children.length);
    }
    if (hasContent) {
      panel.innerHTML = box.innerHTML;
      // klonede formularer skal bindes på ny af temaets formOverride
      panel.querySelectorAll('form.cart-initialized').forEach(function (f) {
        f.classList.remove('cart-initialized');
      });
    }
    panel.setAttribute('data-has-content', hasContent ? '1' : '0');
    syncRecsPanel(container);
    if (hasContent) { bindForms(document); }
  }

  function refreshRecs(container) {
    var box = container.querySelector('[data-hey-recs]');
    if (!box) { updateRecsPanelContent(container); return; }
    // hent først når draweren er åben — ellers bruges der båndbredde på
    // hver sidevisning uden at kunden ser anbefalingerne
    if (!cartIsOpen(container) && !box.getAttribute('data-hey-fetched')) { return; }
    box.setAttribute('data-hey-fetched', '1');
    // Hent anbefalinger for op til 4 kurv-produkter (dyreste først) og
    // flet dem — API'et giver maks 10 pr. produkt, så flere kilder giver
    // en lang, scrollbar liste. Dubletter fjernes på produkt-URL.
    var sources = (box.getAttribute('data-sources') || box.getAttribute('data-source') || '')
      .split(',').filter(Boolean).slice(0, 4);
    if (!sources.length) { box.hidden = true; updateRecsPanelContent(container); return; }
    var totalMax = parseInt(box.getAttribute('data-limit') || '12', 10);
    var intent = box.getAttribute('data-intent') || 'complementary';
    var perFetch = Math.min(10, totalMax);
    var token = ++recsToken;
    Promise.all(sources.map(function (pid) {
      var url = window.Shopify.routes.root + 'recommendations/products' +
        '?product_id=' + pid + '&limit=' + perFetch + '&intent=' + intent + '&section_id=side-cart';
      return fetch(url)
        .then(function (r) { return r.ok ? r.text() : ''; })
        .catch(function () { return ''; });
    })).then(function (texts) {
      if (token !== recsToken) { return; }
      var target = container.querySelector('[data-hey-recs] [data-hey-recs-list]');
      if (!target) { return; }
      var seen = {};
      var merged = [];
      texts.forEach(function (text) {
        if (!text) { return; }
        var list = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-hey-recs-list]');
        if (!list) { return; }
        Array.prototype.forEach.call(list.children, function (li) {
          var link = li.querySelector('h4 a');
          var key = link ? link.getAttribute('href').split('?')[0] : merged.length + '';
          if (seen[key] || merged.length >= totalMax) { return; }
          seen[key] = true;
          merged.push(li);
        });
      });
      if (merged.length) {
        target.innerHTML = '';
        merged.forEach(function (li) { target.appendChild(li); });
        target.closest('[data-hey-recs]').hidden = false;
        bindForms(document);
      } else {
        target.closest('[data-hey-recs]').hidden = true;
      }
      updateRecsPanelContent(container);
    }).catch(function (e) { console.log('hey-cart recs error', e); });
  }

  /* ---------- form-binding via temaets eget event ---------- */

  function bindForms(root) {
    if (root.querySelector('#cart form.f8pr:not(.cart-initialized), #hey-cart-recs-panel form.f8pr:not(.cart-initialized)')) {
      window.dispatchEvent(new CustomEvent('ajaxCart'));
    }
  }

  /* ---------- tidligere set-boks (læser temaets egen tracking) ---------- */

  function formatMoney(cents) {
    if (cents % 100 === 0) { return (cents / 100) + ' kr'; }
    return (cents / 100).toFixed(2).replace('.', ',') + ' kr';
  }

  function imageUrl(src, width) {
    if (!src) { return ''; }
    return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + width;
  }

  function initViewed() {
    var box = document.getElementById('hey-viewed');
    if (!box) { return; }
    if (sessionStorage.getItem('heyViewedClosed') === '1') { return; }
    var closeLink = box.querySelector('[data-hey-viewed-close]');
    if (closeLink) {
      closeLink.addEventListener('click', function (e) {
        e.preventDefault();
        box.hidden = true;
        box.setAttribute('aria-hidden', 'true');
        try { sessionStorage.setItem('heyViewedClosed', '1'); } catch (err) {}
      });
    }
    var data = [];
    try { data = JSON.parse(localStorage.getItem('recentlyViewedProduct')) || []; } catch (e) {}
    if (!data.length) { return; }
    var max = parseInt(box.getAttribute('data-max') || '3', 10);
    var currentId = (typeof general !== 'undefined' && general.viewed_product_id) ? general.viewed_product_id : null;
    // nyeste først; produktet på den aktuelle side vises ikke
    var items = data.slice().reverse().filter(function (item) {
      return item.productId !== currentId;
    }).slice(0, max);
    if (!items.length) { return; }
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 600); };
    idle(function () { loadViewed(items, box); });
  }

  function loadViewed(items, box) {
    Promise.all(items.map(function (item) {
      var path;
      try { path = new URL(item.productUrl, window.location.origin).pathname; }
      catch (e) { return Promise.resolve(null); }
      return fetch(path + '.js')
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    })).then(function (products) {
      var list = box.querySelector('[data-hey-viewed-list]');
      if (!list) { return; }
      list.innerHTML = '';
      products.filter(Boolean).forEach(function (p) {
        var li = document.createElement('li');
        var compare = p.compare_at_price && p.compare_at_price > p.price
          ? '<del>' + formatMoney(p.compare_at_price) + '</del> ' : '';
        li.innerHTML = '<a href="' + p.url + '">' +
          (p.featured_image ? '<img src="' + imageUrl(p.featured_image, 160) + '" loading="lazy" alt="">' : '') +
          '<span class="title"></span>' +
          '<span class="price">' + compare + '<strong>' + formatMoney(p.price) + '</strong></span></a>';
        li.querySelector('.title').textContent = p.title;
        list.appendChild(li);
      });
      if (list.children.length) {
        box.hidden = false;
        box.setAttribute('aria-hidden', 'false');
      }
    });
  }

  /* ---------- flueben-tilvalg på produktsiden (S&D-fallback) ---------- */

  function initProductAddons() {
    var box = document.querySelector('[data-hey-pa][data-source]');
    if (!box) { return; }
    var source = box.getAttribute('data-source');
    var url = window.Shopify.routes.root + 'recommendations/products' +
      '?product_id=' + source + '&limit=' + (box.getAttribute('data-max') || 5) +
      '&intent=complementary&section_id=hey-addons-render';
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (!text) { return; }
        var doc = new DOMParser().parseFromString(text, 'text/html');
        var list = doc.querySelector('[data-hey-pa-list]');
        if (list && list.children.length) {
          box.querySelector('[data-hey-pa-list]').innerHTML = list.innerHTML;
          box.hidden = false;
        }
      })
      .catch(function (e) { console.log('hey-pa error', e); });
  }

  /* ---------- topbar: opdatér milepæls-teaser ved kurvændring ---------- */

  var topbarToken = 0;
  var topbarFirst = true;

  function refreshTopbarMilestone() {
    var el = document.querySelector('[data-hey-topbar-ms]');
    if (!el) { return; }
    // ved sideload er teaseren allerede korrekt serverrenderet
    if (topbarFirst) { topbarFirst = false; return; }
    var token = ++topbarToken;
    fetch(window.Shopify.routes.root + '?section_id=hey-topbar')
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) {
        if (!text || token !== topbarToken) { return; }
        var fresh = new DOMParser().parseFromString(text, 'text/html').querySelector('[data-hey-topbar-ms]');
        if (fresh) {
          el.innerHTML = fresh.innerHTML;
          el.hidden = fresh.hidden;
        }
      })
      .catch(function () {});
  }

  /* ---------- flueben lægger direkte i kurven ---------- */

  var paBusy = false;

  function paToggle(input) {
    if (paBusy) { input.checked = !input.checked; return; }
    var id = parseInt(input.getAttribute('data-id'), 10);
    if (!id) { return; }
    paBusy = true;
    input.disabled = true;
    var done = function (response) {
      paBusy = false;
      input.disabled = false;
      if (response && response.sections && typeof ajaxCart !== 'undefined') {
        // opdater kurv og tæller UDEN at åbne draweren, så valget ikke afbrydes
        ajaxCart.load(response, false);
      }
      var row = input.closest('li');
      if (row) { row.classList.toggle('is-added', input.checked); }
    };
    var fail = function () { paBusy = false; input.disabled = false; input.checked = !input.checked; };

    if (input.checked) {
      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: JSON.stringify({
          items: [{ id: id, quantity: 1, properties: { _hey_source: 'tilvalg' } }],
          sections: 'side-cart'
        })
      }).then(function (r) { return r.json(); })
        .then(function (response) {
          if (response.status) { fail(); return; }
          window.heyTrack('add', { source: 'tilvalg' });
          done(response);
        }).catch(fail);
    } else {
      // fjern varen igen
      fetch(window.Shopify.routes.root + 'cart.js')
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          var line = null;
          cart.items.forEach(function (item) { if (item.variant_id === id) { line = item.key; } });
          if (!line) { paBusy = false; input.disabled = false; return; }
          return fetch(window.Shopify.routes.root + 'cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: line, quantity: 0, sections: 'side-cart' })
          }).then(function (r) { return r.json(); }).then(done);
        }).catch(fail);
    }
  }

  document.addEventListener('change', function (e) {
    var input = e.target;
    if (input && input.matches && input.matches('.hey-pa input[type="checkbox"][data-id]')) {
      var box = input.closest('[data-hey-pa]');
      // 'button'-tilstand håndteres af temaets eget upsell-flow ved Læg i kurv
      if (box && box.getAttribute('data-mode') === 'button') { return; }
      paToggle(input);
    }
  });

  /* ---------- selvkørende nedtælling ([data-hey-cd]) ---------- */

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  var cdNodes = null;

  function tickCountdowns(refresh) {
    if (refresh || !cdNodes) { cdNodes = document.querySelectorAll('[data-hey-cd]'); }
    var nodes = cdNodes;
    if (!nodes.length || document.hidden) { return; }
    var now = Math.floor(Date.now() / 1000);
    nodes.forEach(function (el) {
      var target = parseInt(el.getAttribute('data-target'), 10);
      if (!target) { return; }
      var rem = target - now;
      if (rem <= 0) { el.textContent = '00:00:00'; return; }
      var d = Math.floor(rem / 86400);
      var h = Math.floor((rem % 86400) / 3600);
      var m = Math.floor((rem % 3600) / 60);
      var sec = rem % 60;
      el.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(sec);
    });
  }

  function startCountdowns() {
    tickCountdowns();
    setInterval(tickCountdowns, 1000);
  }

  /* ---------- init ---------- */

  function onRender(container) {
    processGifts(container);
    fixAddonQty(container);
    refreshRecs(container);
    refreshTopbarMilestone();
    // vores eget ur skal også tikke i den gen-renderede drawer
    tickCountdowns(true);
    bindForms(document);
  }

  /* Kurv-draweren hentes normalt FØRST ved klik (ajaxCart.load), hvilket
     giver 1-2 sekunders forsinkelse. Vi forudhenter indholdet i browserens
     tomgang, så panelet åbner øjeblikkeligt — temaets egen mekanik, bare
     kaldt tidligere og uden at åbne panelet. */
  function prefetchCart(container) {
    if (typeof ajaxCart === 'undefined' || !ajaxCart.load) { return; }
    if (container.children.length >= 3) { return; }
    try { ajaxCart.load(false, false); } catch (e) {}
  }

  function start() {
    var container = document.getElementById('cart');
    if (!container) { return; }
    // Forudhent kurven ved FØRSTE tegn på interesse (hover/touch på
    // kurv-ikonet) — ellers først efter 5 sek. Tidligere skete det på
    // hver sidevisning, hvilket gen-initialiserede temaets JS-moduler og
    // gjorde siden mærkbart tung.
    var prefetched = false;
    var doPrefetch = function () {
      if (prefetched) { return; }
      prefetched = true;
      prefetchCart(container);
    };
    document.querySelectorAll('a[data-panel="cart"], li.cart > a').forEach(function (el) {
      el.addEventListener('pointerenter', doPrefetch, { once: true, passive: true });
      el.addEventListener('touchstart', doPrefetch, { once: true, passive: true });
    });
    setTimeout(doPrefetch, 5000);
    // panelet renderes uden for #root i theme.liquid — flyt det ind, så
    // temaets #root-scopede knap-/formularstyling gælder derinde
    var panel = document.getElementById('hey-cart-recs-panel');
    var root = document.getElementById('root');
    if (panel && root && panel.parentElement !== root) {
      root.appendChild(panel);
    }
    new MutationObserver(function () {
      onRender(container);
    }).observe(container, { childList: true });
    // synkronisér anbefalingspanelet når draweren åbnes/lukkes
    new MutationObserver(function () {
      if (cartIsOpen(container)) { refreshRecs(container); }
      syncRecsPanel(container);
    }).observe(container, { attributes: true, attributeFilter: ['aria-hidden', 'class'] });
    onRender(container);
  }



  /* ---------- udsolgte varer bagerst i kollektionen ----------
     Shopify sorterer ikke efter lagerstatus, så udsolgte varer lander
     midt i gitteret. Kortene bærer allerede temaets klasse .unavailable,
     så de kan flyttes bagerst i den viste side. BEMÆRK: det virker pr.
     side — hvilke produkter der havner på side 1, bestemmer Shopify. */
  var sortBusy = false;
  function sortSoldOutLast(root) {
    if (sortBusy) { return; }
    var grids = (root || document).querySelectorAll('ul.l4cl:not(.upsell)');
    sortBusy = true;
    grids.forEach(function (grid) {
      var cards = Array.prototype.slice.call(grid.children);
      var sold = cards.filter(function (li) {
        return li.classList && li.classList.contains('unavailable');
      });
      if (!sold.length || sold.length === cards.length) { return; }
      // står de allerede sidst, gøres intet (undgår unødige reflows)
      var tail = cards.slice(cards.length - sold.length);
      if (tail.every(function (li) { return li.classList.contains('unavailable'); })) { return; }
      var frag = document.createDocumentFragment();
      sold.forEach(function (li) { frag.appendChild(li); });
      grid.appendChild(frag);
    });
    sortBusy = false;
  }

  function watchGrids() {
    if (!document.querySelector('ul.l4cl:not(.upsell)')) { return; }
    sortSoldOutLast(document);
    // filtre og "vis flere" gengiver gitteret — sortér igen bagefter
    var pending = null;
    new MutationObserver(function () {
      if (sortBusy) { return; }
      clearTimeout(pending);
      pending = setTimeout(function () { sortSoldOutLast(document); }, 60);
    }).observe(document.getElementById('content') || document.body, { childList: true, subtree: true });
  }

  /* ---------- leveringslogoer ned i footerens bundlinje ----------
     Temaets footer er én sektion, så rækken kan ikke renderes inde i
     den fra Liquid. Den flyttes derfor ind ved siden af betalings-
     ikonerne, og afsløres først dér — ellers ville den nå at blinke
     forbi som en selvstændig stribe over footeren. */
  function moveDeliveryRow() {
    var row = document.querySelector('[data-hey-del-move]');
    if (!row || row.classList.contains('is-moved')) { return; }
    var bar = document.querySelector('.shopify-section-footer > .base-font');
    if (!bar) { return; }
    var payments = bar.querySelector('ul.l4pm');
    if (payments) { bar.insertBefore(row, payments); } else { bar.appendChild(row); }
    row.classList.add('is-moved');
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      start();
      startCountdowns();
      moveDeliveryRow();
      if (window.heySortSoldOut) { watchGrids(); }
      var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 700); };
      idle(function () { initViewed(); initProductAddons(); });
    });
  } else {
    start();
    startCountdowns();
    moveDeliveryRow();
    if (window.heySortSoldOut) { watchGrids(); }
    var idle = window.requestIdleCallback || function (fn) { return setTimeout(fn, 700); };
    idle(function () { initViewed(); initProductAddons(); });
  }
})();
